import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export const dealerReducer = (state = initialState.partners.dealers, action) => {
  switch (action.type) {
    case types.LOAD_DEALERS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_DEALERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_DEALERS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};
